import {IdNameUsed} from '@domain/id-name-used';
import {TimeUtils} from '@vdw/angular-component-library';
import {Duration} from 'luxon';
import {PatternShift} from './pattern-shift';

export class Pattern extends IdNameUsed {
  private _numDays: number;
  private _startTime: Duration;
  private _patternShifts: PatternShift[];

  public constructor(id: number, name: string, numDays: number, startTime?: Duration, patternShifts?: PatternShift[], used: boolean = false) {
    super(id, name, used);
    this._numDays = numDays;
    this._startTime = startTime;
    this._patternShifts = patternShifts;
  }

  public get numDays(): number {
    return this._numDays;
  }

  public set numDays(value: number) {
    this._numDays = value;
  }

  public get startTime(): Duration {
    return this._startTime;
  }

  public set startTime(value: Duration) {
    this._startTime = value;
  }

  public get patternShifts(): PatternShift[] {
    return this._patternShifts;
  }

  public set patternShifts(value: PatternShift[]) {
    this._patternShifts = value;
  }

  public static fromJSON(patternJSON: any): Pattern {
    return new Pattern(
      patternJSON.id,
      patternJSON.name,
      patternJSON.numDays,
      patternJSON.startTimeFromMidnight ? TimeUtils.convertTimeSpanToDuration(patternJSON.startTimeFromMidnight) : null,
      patternJSON.patternShifts?.map((patternShiftJSON: any) => PatternShift.fromJSON(patternShiftJSON)),
      patternJSON.used
    );
  }

  public toJSON(): JSON {
    return {
      name: this._name,
      numDays: this._numDays,
      startTimeFromMidnight: this._startTime.toFormat('hh:mm:ss'),
      patternShifts: this._patternShifts.map((patternShift: PatternShift) => patternShift.toJSON())
    } as any as JSON;
  }
}
